import api from 'api';

export const loadEventsGrid = api('POST /api/events/grid');
